import { Card, Grid, Progress, Table, type TableColumnsType } from 'antd';
import { useMemo } from 'react';
import type { TaskStatisticsOutputDto } from '../model';
import { getSuccessPercent, getSuccessRateColor } from '../utils/success-rate';

type ModelStat = TaskStatisticsOutputDto['model_stats'][number];

const commonColumns: TableColumnsType<ModelStat> = [
  {
    title: '成功',
    dataIndex: 'succeeded',
  },
  {
    title: '失败',
    dataIndex: 'failed',
  },
  {
    title: '其他',
    dataIndex: 'other',
  },
  {
    title: '信用点',
    dataIndex: 'cost',
  },
  {
    title: '成功率',
    key: 'success_rate',
    render: (_, record) => {
      const percent = getSuccessPercent(
        record.succeeded,
        record.failed,
        record.other,
      );

      return (
        <Progress
          percent={percent}
          strokeColor={getSuccessRateColor(percent)}
          size="small"
        />
      );
    },
  },
];

export function ModelStatisticsTable(props: {
  data: TaskStatisticsOutputDto['model_stats'];
  formatModelName?: (model: string) => string;
}) {
  const { formatModelName } = props;
  const { xs } = Grid.useBreakpoint();
  const columns = useMemo<TableColumnsType<ModelStat>>(
    () => [
      {
        title: '模型',
        dataIndex: 'model',
        render: (model: string) => formatModelName?.(model) ?? model,
      },
      ...commonColumns,
    ],
    [formatModelName],
  );

  return (
    <Card title="模型统计">
      <Table
        rowKey={(record) => record.model}
        size="small"
        scroll={xs ? { x: 800 } : void 0}
        columns={columns}
        dataSource={props.data}
        pagination={false}
      />
    </Card>
  );
}
